import { ref } from 'vue'

export const useToolTip = () => {
  const tooltip = ref<ToolTip | null>(null)
  const timeout = ref<number | undefined>(undefined)

  const close = () => {
    tooltip.value = null
  }

  const remove = (removeTooltip: ToolTip) => {
    if (timeout.value) {
      clearTimeout(timeout.value)
      timeout.value = undefined
    }

    setTimeout(() => {
      if (removeTooltip.id !== tooltip.value?.id) return

      close()
    }, 300)
  }

  const updateToolTip = (toolTip: ToolTip) => {
    if (timeout.value) {
      clearTimeout(timeout.value)
      timeout.value = undefined
    }

    tooltip.value = toolTip
  }

  return {
    tooltip,
    close,
    remove,
    updateToolTip,
  }
}
